import React from 'react'
import { useTranslation } from 'react-i18next'
import imageStyles from '../Image.module.css'
import styles from './ErrorPage.module.css'
import errorPicture from './error.png'

export interface ErrorPageProps {
  messageSubKey?: string
  withLogoutLink?: boolean
  withLinkToListingOverview?: boolean
}

const ErrorPage: React.FC<ErrorPageProps> = ({ messageSubKey, withLogoutLink, withLinkToListingOverview }) => {
  const { t } = useTranslation()
  return (
    <>
      <div className='content-wrapper'>
        <div className={`align-center padding-xl margin-xl ${styles.container}`}>
          <div className={`${imageStyles['image-container']}`}>
            <img src={errorPicture} className={`inline-block ${imageStyles['image']}`} />
          </div>
          <p id='page-error-message' className='font-body-medium-regular padding-vertical-xl'>
            {t(`message.${messageSubKey ?? 'error'}`, 'Sorry, an error has occurred')}
          </p>

          {withLinkToListingOverview && (
            <a className='button button-primary' href='/scoutmanager/angebotsliste/app/overview.html'>
              {t('message.listingOverviewButton')}
            </a>
          )}

          {withLogoutLink && (
            <a className='button margin-left palm-margin-top-l' href='/sso/logout.go'>
              {t('message.logoutButton')}
            </a>
          )}
        </div>
      </div>
    </>
  )
}

export default ErrorPage
